export const cases = [
  {
    title: "Case study",
    content: "Adding more protein while keeping taste good is a feat and requires lots of RnD. That's where we help.",
    linkUrl: "https://sugarlike.ca"
  },
  {
    title: "Sugarlike Sweet",
    content: "Did you know you can replace sugar with Sugarlike in 1:1 ratio? Saving you from lengthy trial and errors.",
    linkUrl: "https://sugarlike.ca"
  },
]
